import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-black" }
const _hoisted_2 = {
  key: 4,
  class: "flex my-10"
}

import { TileContentModel } from '@/types/B2BcontentServerContract';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileHorizontalSliderTile',
  props: {
    data: null,
    aspectRatio: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.data.media)
      ? (_openBlock(), _createBlock(_component_RouterLinkConditional, {
          key: 0,
          to: __props.data?.link?.url,
          target: __props.data?.link?.target,
          "spa-enabled": __props.data?.link?.spaLink,
          title: __props.data?.link?.text || __props.data?.link?.title,
          class: "w-full h-full overflow-hidden mb-x2"
        }, {
          default: _withCtx(() => [
            _createVNode(MediaHandler, {
              class: "overflow-image-padding",
              "media-block": __props.data.media,
              "media-aspect-ratio": 4/3
            }, null, 8, ["media-block"])
          ]),
          _: 1
        }, 8, ["to", "target", "spa-enabled", "title"]))
      : _createCommentVNode("", true),
    (__props.data.title)
      ? (_openBlock(), _createBlock(_component_RouterLinkConditional, {
          key: 1,
          to: __props.data?.link?.url,
          target: __props.data?.link?.target,
          "spa-enabled": __props.data?.link?.spaLink,
          title: __props.data?.link?.text || __props.data?.link?.title,
          class: "block mb-x1 o-text-h3 text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.data.title), 1)
          ]),
          _: 1
        }, 8, ["to", "target", "spa-enabled", "title"]))
      : _createCommentVNode("", true),
    (__props.data.subheading)
      ? (_openBlock(), _createBlock(_component_RouterLinkConditional, {
          key: 2,
          to: __props.data?.link?.url,
          target: __props.data?.link?.target,
          "spa-enabled": __props.data?.link?.spaLink,
          title: __props.data?.link?.text || __props.data?.link?.title,
          class: "block text-center o-text-caption uppercase mb-x1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.data.subheading), 1)
          ]),
          _: 1
        }, 8, ["to", "target", "spa-enabled", "title"]))
      : _createCommentVNode("", true),
    (__props.data.text)
      ? (_openBlock(), _createBlock(_component_RouterLinkConditional, {
          key: 3,
          to: __props.data?.link?.url,
          target: __props.data?.link?.target,
          "spa-enabled": __props.data?.link?.spaLink,
          title: __props.data?.text,
          class: "block text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.data.text), 1)
          ]),
          _: 1
        }, 8, ["to", "target", "spa-enabled", "title"]))
      : _createCommentVNode("", true),
    (__props.data?.link?.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_RouterLinkConditional, {
            to: __props.data.link.url,
            target: __props.data.link.target,
            "spa-enabled": __props.data.link.spaLink,
            class: "c-button c-button--current-color mx-auto"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data.link.text), 1)
            ]),
            _: 1
          }, 8, ["to", "target", "spa-enabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})